import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../store";

export default function Footer() {
  const { settings } = useApp();
  const s = settings || {};
  const brandTop = s.brand_name_top || "World of";
  const brandBottom = s.brand_name_bottom || "Floral Absolutes";
  return (
    <footer className="bg-[#1E1F1E] text-[#FAF9F6] mt-32">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-4 gap-12">
        <div>
          <h3 className="font-serif-display text-3xl leading-tight mb-4">{brandTop}<br/>{brandBottom}</h3>
          <p className="text-xs leading-relaxed text-[#8A8D8A] max-w-xs">
            {s.footer_about || "Sacred florals & artisanal attars from Kannauj. Distilled by copper deg-bhapka. Shipped worldwide."}
          </p>
        </div>
        <div>
          <h4 className="overline mb-5 text-[#B87333]">Shop</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/catalog" className="hover:text-[#B87333]">All Products</Link></li>
            <li><Link to="/catalog?category=Floral%20%26%20Absolute" className="hover:text-[#B87333]">Floral Absolutes</Link></li>
            <li><Link to="/catalog?category=Attar" className="hover:text-[#B87333]">Traditional Attars</Link></li>
            <li><Link to="/catalog?category=Wood%20%26%20Resin" className="hover:text-[#B87333]">Wood &amp; Resin</Link></li>
            <li><Link to="/catalog?category=Herb%20%26%20Grass" className="hover:text-[#B87333]">Herb &amp; Grass</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5 text-[#B87333]">Trade</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/inquiry" className="hover:text-[#B87333]">B2B Inquiry / RFQ</Link></li>
            <li><Link to="/blog" className="hover:text-[#B87333]">Journal</Link></li>
            <li><span className="text-[#8A8D8A]">Bulk &amp; private label</span></li>
            <li><span className="text-[#8A8D8A]">CAS &amp; COA docs</span></li>
            <li><span className="text-[#8A8D8A]">Worldwide shipping</span></li>
          </ul>
        </div>
        <div>
          <h4 className="overline mb-5 text-[#B87333]">House</h4>
          <ul className="space-y-3 text-sm">
            <li><span className="text-[#8A8D8A]">{s.footer_contact_location || "Kannauj, Uttar Pradesh, India"}</span></li>
            <li><span className="text-[#8A8D8A]">{s.footer_contact_email || "hello@floralabsolutes.com"}</span></li>
            <li><span className="text-[#8A8D8A]">{s.footer_contact_phone || "+91 — by appointment"}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between text-xs text-[#8A8D8A]">
          <span>© {new Date().getFullYear()} {brandTop} {brandBottom}. All distillations reserved.</span>
          <span className="overline text-[10px]">Crafted with copper · Distilled with patience</span>
        </div>
      </div>
    </footer>
  );
}
